export default Object.freeze({
    ORDER_STATUS_CANCELLED: 'cancelled',
    ORDER_STATUS_COMPLETE: 'complete',
    ORDER_STATUS_PENDING: 'pending',
    ORDER_STATUS_PROCESSED: 'processed', //TODO - Remove this and make a processing_status enum instead.  This overloads the order-status
    ORDER_STATUS_RETURNED: 'returned',
});



// WEBPACK FOOTER //
// ./src/Assets/components/Orders/consts/order_statuses.js